import { formatMoney } from "./money.js";
import { outstandingCents } from "./status.js";
/**
 * Every source, in the order Inicio's «Te deben» lists its lines: a new
 * vertical's source joins this list and nowhere in the kernel.
 */
export const RECEIVABLE_SOURCES = ["cuota", "pedido", "deuda"];
export const RECEIVABLE_SOURCE_LABELS = {
    cuota: "Cuotas",
    pedido: "Pedidos",
    deuda: "Fiado",
};
/**
 * THE LIBRO'S TITLE FOR A COLLECTION, by what it settled. `null` is the
 * business's own word for an order («Pedido», «Ticket»), which only the
 * caller knows. `cashEntryLabel` prints it and the server's `labelKeySql`
 * searches it: one table, so the two cannot drift apart.
 */
export const ENTRY_SOURCE_LABELS = {
    cuota: "Cuota cobrada",
    pedido: null,
    deuda: "Deuda",
};
/**
 * Whether this much may be collected (or paid) against this receivable. THE
 * ONE MONEY RULE: the phone, the browser and the server answer this exact
 * function, and `kernel/receivable` runs the same subtraction in SQL under
 * a lock. A vertical that has its own reason to refuse (a quote takes no
 * money) asks that first and this second.
 *
 * EDITING IS NOT COLLECTING: a payment being corrected already counts inside
 * `paidCents`, so whoever edits subtracts that payment's own allocation
 * before asking. This function knows only a ceiling.
 */
export function canSettle(receivable, amountCents) {
    if (!Number.isInteger(amountCents) || amountCents <= 0) {
        return { ok: false, message: "El monto debe ser mayor que cero." };
    }
    const left = outstandingCents(receivable.amountCents, receivable.paidCents);
    if (left <= 0)
        return { ok: false, message: "Ya está pagado." };
    if (amountCents > left) {
        return { ok: false, message: `El monto no puede ser mayor que lo que falta: ${formatMoney(left)}.` };
    }
    return { ok: true };
}
/** Whether the total may become this, given what was already collected. */
export function canLowerAmountTo(receivable, amountCents) {
    if (!Number.isInteger(amountCents) || amountCents < 0) {
        return { ok: false, message: "El monto no es válido." };
    }
    if (amountCents < receivable.paidCents) {
        return {
            ok: false,
            message: `Ya se cobraron ${formatMoney(receivable.paidCents)}: el total no puede ser menor.`,
        };
    }
    return { ok: true };
}
